import { apiGetRelationshipLevels } from "@api/relationshipLevel";
import {
  setRelationshipLevels,
  setRelationshipLevelsLoading,
  setRelationshipLevelsError,
} from "@app-redux/slices/relationshipLevelSlice";
import { createAsyncThunk } from "@reduxjs/toolkit";
import type { RelationshipLevelRes } from "@api/relationshipLevel";

export const getRelationshipLevels = createAsyncThunk<RelationshipLevelRes[]>(
  "relationshipLevel/get",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(setRelationshipLevelsLoading());
      const data = await apiGetRelationshipLevels();
      thunkAPI.dispatch(setRelationshipLevels(data));
      return data;
    } catch (e: any) {
      thunkAPI.dispatch(
        setRelationshipLevelsError(e.message ?? "Failed to fetch relationship levels")
      );
      return thunkAPI.rejectWithValue(e.message ?? e.response?.data?.message);
    }
  }
);
